import { Link } from 'react-router-dom';
import { TextAndIconButton } from 'src/components/atomsLegacy';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ tablet?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${(props) => (props.tablet ? 'column' : 'row')};
`;

export const InfoContainer = styled.div`
  margin-left: 32px;
  margin-bottom: 20px;
  h1,
  p {
    margin-top: 0px;
  }
  h1 {
    margin-bottom: 14px;
  }
  p {
    margin-bottom: 0px;
  }
`;

export const StyledLink = styled(Link)`
  margin-top: 30px;
  margin-bottom: 16px;
  display: flex;
  column-gap: 4px;
  color: ${(props) => props.theme.newPalette.neutral.N500};
  font-size: 14px;
  align-items: center;
  text-decoration: none;
`;

export const ButtonContainer = styled.div<{ mobile?: boolean }>`
  margin-right: 32px;
  display: flex;
  height: 100%;
  align-self: flex-end;
  margin-bottom: 20px;
  column-gap: 8px;
  ${(props) =>
    props.mobile &&
    css`
      width: 100%;
      justify-content: center;
      margin-right: 0px;
    `}
`;

export const DeleteButton = styled(TextAndIconButton)`
  background-color: ${(props) => props.theme.newPalette.neutral.N200};
  color: ${(props) => props.theme.newPalette.neutral.N1000};
  padding: 7px 16px;
  gap: 8px;
  border: solid 1px ${(props) => props.theme.newPalette.neutral.N500};
`;

export const SubmitButton = styled(TextAndIconButton)`
  background-color: ${(props) => props.theme.newPalette.turquoise.T300};
  color: ${(props) => props.theme.newPalette.neutral.N0};
  padding: 7px 16px;
  gap: 8px;
`;
